export default __webpack_public_path__ + "static/1-e65664a52d636d35cd64cdea0d86d831.jpeg";